import React from 'react';
import { Hero } from './components/Hero';
import { PainSection } from './components/PainSection';
import { WhatsIncluded } from './components/WhatsIncluded';
import { HowItWorks } from './components/HowItWorks';
import { BonusSection } from './components/BonusSection';
import { Testimonials } from './components/Testimonials';
import { PricingCTA } from './components/PricingCTA';
import { FAQ } from './components/FAQ';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-cream font-inter text-navy selection:bg-gold selection:text-navy-dark" data-id="element-0">
      <Hero data-id="element-1" />
      <PainSection data-id="element-2" />
      <WhatsIncluded data-id="element-3" />
      <HowItWorks data-id="element-4" />
      <BonusSection data-id="element-5" />
      <Testimonials data-id="element-6" />
      <PricingCTA data-id="element-7" />
      <FAQ data-id="element-8" />
      <Footer data-id="element-9" />
    </div>;
}